import {custom, deserialize, list, serialize, SKIP} from "serializr";

import {TriggerBase} from "./TriggerBase";
import {TriggerGeneric} from "../TriggerGeneric";
import {TriggerItem, TriggerItemGroup} from "../TriggerItem";
import {TriggerQuest} from "../TriggerQuest";
import {TriggerTalk} from "../TriggerTalk";
import {TriggerOrder} from "../TriggerOrder";
import {TriggerKind} from "./TriggerKind";
import {TriggerTutorial} from "../TriggerTutorial";
import {TriggerCurrency} from "../TriggerCurrency";
import {TriggerProduct} from "../TriggerProduct";
import {TriggerTrader} from "../TriggerTrader";
import {TriggerShip} from "../TriggerShip";
import {TriggerJohan} from "../TriggerJohan";
import {TriggerSmartOffer} from "../TriggerSmartOffer";

export class TriggerSchema {
    static custom() {
        return list(custom(
            (value) => {
                if (!(value instanceof TriggerBase)) {
                    console.error("invalid type");
                    return SKIP;
                } else if (TriggerKind.GENERIC.equal(value.kind)) {
                    return serialize(TriggerGeneric, value);
                } else if (TriggerKind.ITEM.equal(value.kind)) {
                    return serialize(TriggerItem, value);
                } else if (TriggerKind.ITEM_GROUP.equal(value.kind)) {
                    return serialize(TriggerItemGroup, value);
                } else if (TriggerKind.QUEST.equal(value.kind)) {
                    return serialize(TriggerQuest, value);
                } else if (TriggerKind.TALK.equal(value.kind)) {
                    return serialize(TriggerTalk, value);
                } else if (TriggerKind.TUTORIAL.equal(value.kind)) {
                    return serialize(TriggerTutorial, value);
                } else if (TriggerKind.ORDER.equal(value.kind)) {
                    return serialize(TriggerOrder, value);
                } else if (TriggerKind.SMART_OFFER.equal(value.kind)) {
                    return serialize(TriggerSmartOffer, value);
                } else if (TriggerKind.CURRENCY.equal(value.kind)) {
                    return serialize(TriggerCurrency, value);
                } else if (TriggerKind.PRODUCT.equal(value.kind)) {
                    return serialize(TriggerProduct, value);
                } else if (TriggerKind.SHIP.equal(value.kind)) {
                    return serialize(TriggerShip, value);
                } else if (TriggerKind.TRADER.equal(value.kind)) {
                    return serialize(TriggerTrader, value);
                } else if (TriggerKind.JOHAN.equal(value.kind)) {
                    return serialize(TriggerJohan, value);
                } else {
                    console.error("unknown guard kind");
                    return SKIP;
                }
            },
            (value) => {
                if (TriggerKind.GENERIC.equal(value.kind)) {
                    return deserialize(TriggerGeneric, value);
                } else if (TriggerKind.ITEM.equal(value.kind)) {
                    return deserialize(TriggerItem, value);
                } else if (TriggerKind.ITEM_GROUP.equal(value.kind)) {
                    return deserialize(TriggerItemGroup, value);
                } else if (TriggerKind.QUEST.equal(value.kind)) {
                    return deserialize(TriggerQuest, value);
                } else if (TriggerKind.TALK.equal(value.kind)) {
                    return deserialize(TriggerTalk, value);
                } else if (TriggerKind.TUTORIAL.equal(value.kind)) {
                    return deserialize(TriggerTutorial, value);
                } else if (TriggerKind.ORDER.equal(value.kind)) {
                    return deserialize(TriggerOrder, value);
                } else if (TriggerKind.SMART_OFFER.equal(value.kind)) {
                    return deserialize(TriggerSmartOffer, value);
                } else if (TriggerKind.CURRENCY.equal(value.kind)) {
                    return deserialize(TriggerCurrency, value);
                } else if (TriggerKind.PRODUCT.equal(value.kind)) {
                    return deserialize(TriggerProduct, value);
                } else if (TriggerKind.SHIP.equal(value.kind)) {
                    return deserialize(TriggerShip, value);
                } else if (TriggerKind.TRADER.equal(value.kind)) {
                    return deserialize(TriggerTrader, value);
                } else if (TriggerKind.JOHAN.equal(value.kind)) {
                    return deserialize(TriggerJohan, value);
                } else {
                    console.error("unknown guard kind");
                    return SKIP;
                }
            }
        ))
    }
}